import React from 'react'

/*
    arrow: (
      <svg viewBox="0 0 60 30" width="60" height="30" x="1580" y="1283">
        <polygon fill="#e9e9e9" points="0, 0 60, 0 30, 30" />
      </svg>
    ),
*/

export default {
  forSale: true,
  viewable: true,
  title: 'Áfangi A',
  key: 'afangi-a',
  rect: {
    className: 'bg-primary text-white badge-arrow',
    props: {
      x: 1345,
      y: 1160,
      width: 420,
      height: 150,
    },
  },
  path: {
    d: 'm1511.25 1656.11-431.04-66.38-180 34.56-44.19-7.88L632.3 1578l-64.76-17.52 201.37-37.6-1.66-36.43 90.27-25.93 85.77-.54 81.56 16.21 34.95-6.51-.8-32.23 80.89-24.02h53.95l122.14-24.59-.32-27.16 105.11-14.79h58.02l.48-6.59 90.48-13.66 66.7-3.69v23.78l100.43 2.9 183.12 28.44 63.64-4.5 56.36 19.72v2.67l153 24.38 35.68 5.46 39.75 6.06 3.43-1.61 38.86 2.22 155.17 23.55v6.79l98.84 14.42-166.87 40.88-31.5 1.93-102.89 21-116.52 18.18-49.52-8.01-27.27 15.54.04 2.57-47.8 7.72-29.25-3.3-20 11.08-461.9 71.29z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/floahverfid/afangi-a.jpg'),
      width: 3840,
      height: 2160,
    },
    list: [
      {
        lod: 'selfloi-4',
        d: 'm2190.09 753.36 375.59 16.79 30.78 350.34-90.35-4.35-.22-7.6-230.22-9.89-.78 5.18-112.84-4.86 4.98-330.99 23.06-14.62z',
      },
      {
        lod: 'selfloi-3',
        d: 'm1408.54 716.23 663.48 30.86 21.8 17.04-15.83 440.96-38.93-1.85-1.81 38.73-692.3-36.12 63.59-489.62z',
      },
      {
        lod: 'selfloi-2',
        d: 'm2156.5 1516.21 877.93-52.28 21.82-321.3-550.14-26.49-.32-7.71-230.12-9.78-.8 5.3-112.82-4.98-5.55 417.24z',
      },
      {
        lod: 'selfloi-1',
        d: 'm1266.89 1809.63 78.06-603.78 692.3 36.12 39.64 1.51-15.96 448.61-98.81-4.86-6.19 110.81-466.5 24.28-222.54-12.69z',
      },
      {
        lod: 'keldufloi-8',
        d: 'm1512.36 188.41 152.31 6.71-85.17 477.8-384.71-17.76 50.82-391.02 266.75-75.73z',
      },
      {
        lod: 'keldufloi-6',
        d: 'm1664.67 195.12 373.49 15.93-27.19 456.65-1.26 25.12-430.21-19.9 85.17-477.8z',
      },
      {
        lod: 'keldufloi-4',
        d: 'm2415.68 227.61 27.21 469.5-20.78 14.89-370.31-17.14.56-24.83-41.39-2.33 27.19-456.65 377.52 16.56z',
      },
      {
        lod: 'keldufloi-2',
        d: 'm3083.61 742.96 17.65-262.74-57.86-226.2-564.75-23.71 35.92 470.65 23.47 16.08 545.57 25.92z',
      },
      {
        lod: 'keldufloi-1',
        d: 'm3079.72 794.1-23.47 348.53-459.79-22.14-30.78-350.34 514.04 23.95z',
      },
    ],
  },
}
